import { render, staticRenderFns } from "./userChangePassword.vue?vue&type=template&id=5b70e59a&lang=pug"
import script from "./userChangePassword.vue?vue&type=script&lang=js"
export * from "./userChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports